import { ReactNode } from 'react'
import { FormSelectWithGroups } from 'shared/components/form-select/form-select-with-groups'
import { useCalendars } from './hooks/use-calendars'
import { CalendarAccessRoleEnum, CalendarInterface } from './types'

const allowedAccessRoles: CalendarAccessRoleEnum[] = [
  CalendarAccessRoleEnum.Owner,
  CalendarAccessRoleEnum.Writer,
]

const SEPARATOR = `__${crypto.randomUUID()}__`

const setUniqueCalendarValue = (calendarId: string, integrationId: string) =>
  `${calendarId}${SEPARATOR}${integrationId}`
const getCalendarDataFromUniqueValue = (value: string) => {
  const [calendarId, integrationId] = value.split(SEPARATOR)
  return { calendarId, integrationId }
}

export const GoogleCalendarSelector = ({
  calendar,
  disabled,
  label,
  className,
  onChange,
}: {
  calendar?: CalendarInterface
  disabled?: boolean
  label?: ReactNode
  className?: string
  onChange: (calendarId?: string, integrationId?: string) => void
}) => {
  const { data: calendars } = useCalendars()
  const groups = calendars?.map(calendar => ({
    id: calendar.integration.id,
    caption: calendar.integration.googleUserEmail,
  }))
  const calendarsOptions = calendars
    ?.filter(calendar => allowedAccessRoles.includes(calendar.accessRole))
    ?.map(calendar => ({
      id: setUniqueCalendarValue(calendar.id, calendar.integration.id),
      group: calendar.integration.id,
      caption: calendar.name,
      customCaption: (
        <div className="flex items-center gap-2">
          <span
            className="h-2 w-2 rounded-full"
            style={{ backgroundColor: calendar.backgroundColor }}
          ></span>{' '}
          {calendar.name}
        </div>
      ),
    }))

  return (
    <FormSelectWithGroups
      label={label}
      groups={groups ?? []}
      data={calendarsOptions ?? []}
      disabled={disabled}
      isPreFetching={!calendars}
      value={calendar ? setUniqueCalendarValue(calendar.id, calendar.integration.id) : undefined}
      onChange={value => {
        if (!value) return
        const { calendarId, integrationId } = getCalendarDataFromUniqueValue(value)
        onChange(calendarId, integrationId)
      }}
      withoutCloseIcon
      containerClassName={className}
    />
  )
}
